import React from 'react';

import { RefundProps } from '../types';
import { useI18n } from '~Hooks';

// WaiterAid gift cards don't support refunds through their API.
// Similar to Retain24 - the redeem is permanent.
export const RefundWaiterAidGiftcard = (props: RefundProps) => {
  const { i18n } = useI18n();
  const { onFail } = props;

  onFail(i18n('History.RefundFailed.R24'));
  return <></>;
};
